import { useContext } from 'react';

import { CustomerLeadStepAdditionalInformation } from 'src/components/customers/steps/AdditionalInformation/CustomerLeadStepAdditionalInformation';
import { CustomerLeadStepContacts } from 'src/components/customers/steps/Contact/CustomerLeadStepContacts';
import { CustomerLeadStepDone } from 'src/components/customers/steps/Done/CustomerLeadStepDone';
import { CustomerLeadStepProductSpecifications } from 'src/components/customers/steps/ProductSpecifications/CustomerLeadStepProductSpecifications';
import { CustomerLeadStepQuantities } from 'src/components/customers/steps/Quantities/CustomerLeadStepQuantities';
import { CustomerLeadStepStart } from 'src/components/customers/steps/Start/CustomerLeadStepStart';
import { CustomersContext } from 'src/pages/CustomersPage/CustomersPage.context';
import { CustomerPageStep } from 'src/pages/CustomersPage/CustomersPage.context.types';

type CustomerLeadStepsProps = {
  customerProductLeadId: string;
};

export function CustomerLeadSteps({ customerProductLeadId }: Readonly<CustomerLeadStepsProps>) {
  const { customerStep } = useContext(CustomersContext);

  return customerStep === CustomerPageStep.Start ? (
    <CustomerLeadStepStart />
  ) : customerStep === CustomerPageStep.Quantities ? (
    <CustomerLeadStepQuantities customerProductLeadId={customerProductLeadId} />
  ) : customerStep === CustomerPageStep.ProductSpecifications ? (
    <CustomerLeadStepProductSpecifications customerProductLeadId={customerProductLeadId} />
  ) : customerStep === CustomerPageStep.AdditionalInformation ? (
    <CustomerLeadStepAdditionalInformation customerProductLeadId={customerProductLeadId} />
  ) : customerStep === CustomerPageStep.ShippingAndContacts ? (
    <CustomerLeadStepContacts customerProductLeadId={customerProductLeadId} />
  ) : customerStep === CustomerPageStep.Done ? (
    <CustomerLeadStepDone />
  ) : null;
}
